import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { AppProvider } from './contexts/AppContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import CalendarEditorPage from './pages/CalendarEditorPage';
import BookingPage from './pages/BookingPage';
import PollPage from './pages/PollPage';
import PollEditorPage from './pages/PollEditorPage';
import PollResultsPage from './pages/PollResultsPage';
import BookingConfirmationPage from './pages/BookingConfirmationPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppProvider>
          <Router>
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute>
                      <DashboardPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/calendar/new" 
                  element={
                    <ProtectedRoute>
                      <CalendarEditorPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/calendar/edit/:id" 
                  element={
                    <ProtectedRoute>
                      <CalendarEditorPage />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/book/:shareId" element={<BookingPage />} />
                <Route 
                  path="/poll/new" 
                  element={
                    <ProtectedRoute>
                      <PollEditorPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/poll/edit/:id" 
                  element={
                    <ProtectedRoute>
                      <PollEditorPage />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/poll/:shareId" element={<PollPage />} />
                <Route path="/poll/:shareId/results" element={<PollResultsPage />} />
                <Route path="/booking/confirmation/:bookingId" element={<BookingConfirmationPage />} />
              </Routes>
            </Layout>
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 3000,
                  theme: {
                    primary: 'green',
                    secondary: 'black',
                  },
                },
              }}
            />
          </Router>
        </AppProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;